<!--
 Copyright 2022 by domX Private Company

 All rights reserved,
 also regarding any disposal, exploitation, reproduction,
 editing, distribution, as well as in the event of
 applications for industrial property rights.

 This software contains proprietary and confidential
 information of domX Private Company.
 The disclosure of confidential information without
 express authorization is prohibited.

 This software may include Open Source Software.
 As far as Open Source Software is included,
 your rights for the respective Open Source Software
 components are governed by the applicable
 Open Source Software licenses.
-->

<template class="fill-height">
  <v-card
    flat
    class="secondary fill-height pa-12"
    height="25%">
    <v-list class="secondary" min-width="400px">
      <v-subheader class="display-1 grayBold--text">
        {{$t("logout")}}
      </v-subheader>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="subtitle-2 grayBold--text">
            {{$t("logout_warning")}}{{$t("question_mark")}} 
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-card-actions>
      <v-spacer/>
      <v-btn
        depressed
        right
        light
        color="grayBold--text secondary"
        @click="hideModal()"
      >
        {{$t("cancel")}}
      </v-btn>
      <v-btn
        color="primary"
        depressed
        right
        large
        class="modal-logout"
        @click="doLogout"><v-icon left>mdi-lock-outline</v-icon>{{$t("logout_uppercase")}}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import { commonModule, installationsModule } from '@/store/modules/store-accessor'

@Component
export default class LogOutModal extends Vue {

  async hideModal () {
    commonModule.hideModal();
  }

  async mounted() {
    commonModule.initSnackbar({});
  }

  doLogout () {
    (window as any).sharedKeycloak.logout();
    this.hideModal()
  }
};
</script>
